const LS_PREFIX = 'mdv-onboarding-seen';

function key(projectName) {
  return `${LS_PREFIX}:${String(projectName || 'default')}`;
}

export function hasSeenOnboarding(projectName) {
  try {
    return localStorage.getItem(key(projectName)) === '1';
  } catch {
    return true;
  }
}

export function markOnboardingSeen(projectName) {
  try {
    localStorage.setItem(key(projectName), '1');
  } catch {
    // ignore
  }
}
